import React, { Component} from 'react';
import './Main.css';
import { SocialIcon } from 'react-social-icons'
import Sidebar from './pages/Sidebar';

import People from './pages/People';
import Pubs from './pages/Pubs';
import About from './pages/About';
import Join from './pages/Join';
import Research from './pages/Research';
import News from './pages/News';

let NEWS = [
    {"date": "08-22-2024", "type": "News", "content": "I (Michael) finally finished the website!"},
    {"date": "03-21-2024", "type": "News", "content": "Michael passes his thesis proposal and is now a PhD candidate!"}
]

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
        expanded: false,
        expandedPage: null,
        showPeople: false,
        showPubs: false,
        showAbout: false,
        showResearch: false,
        showJoin: false,
        showNews: false
    };
    
    this.changePage = this.changePage.bind(this);
    this.resetPage = this.resetPage.bind(this);
    this.expandTheDiv = this.expandTheDiv.bind(this);
    this.showPeople = this.showPeople.bind(this);
    this.showPubs = this.showPubs.bind(this);
    this.showAbout = this.showAbout.bind(this);
    this.showResearch = this.showResearch.bind(this);
    this.showJoin = this.showJoin.bind(this);
    this.showNews = this.showNews.bind(this);
    this.hidePeople = this.hidePeople.bind(this);
    this.hidePubs = this.hidePubs.bind(this);
    this.hideAbout = this.hideAbout.bind(this);
    this.hideResearch = this.hideResearch.bind(this);
    this.hideJoin = this.hideJoin.bind(this);
    this.hideNews = this.hideNews.bind(this);
  }

  componentDidUpdate(){
  
  }
 
  componentDidMount(){
    document.querySelectorAll('.frame').forEach(function(frame){
        frame.classList.add("fadeInAnimationFast");
    });
    document.getElementById("name").classList.add("fadeInAnimationFast");
    setTimeout(
        function() {
            document.querySelectorAll('.frame').forEach(function(frame){
                frame.classList.remove("fadeInAnimationFast");
            });
            document.getElementById("name").classList.remove("fadeInAnimationFast");
    }, 1000);
  }

  changePage(page){
    this.setState({expandedPage:page});
  }

  showPeople(){
    this.setState({showPeople: true, expandedPage:"people"});
  }

  showPubs(){
    this.setState({showPubs: true, expandedPage:"publications"});
  }

  showAbout(){
    this.setState({showAbout: true, expandedPage:"about"});
  }

  showResearch(){
    this.setState({showResearch: true, expandedPage:"research"});
  }

  showJoin(){
    this.setState({showJoin: true, expandedPage:"join"});
  }

  showNews(){
    this.setState({showNews: true, expandedPage:"news"});
  }


  hidePeople(){
    this.setState({showPeople: false});
  }

  hidePubs(){
    this.setState({showPubs: false});
  }

  hideAbout(){
    this.setState({showAbout: false});
  }

  hideResearch(){
    this.setState({showResearch: false});
  }

  hideJoin(){
    this.setState({showJoin: false});
  }

  hideNews(){
    this.setState({showNews: false});
  }



  resetPage(){
    this.setState({expandedPage:null, 
        expanded:false, 
        showPeople: false, 
        showPubs: false,
        showAbout: false,
        showResearch: false,
        showJoin: false,
        showNews: false
    });
  }

  expandTheDiv(e){
    if (this.state.expanded){
        return;
    }

    if (e.currentTarget.id == "people"){
        this.setState({ showPeople: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    if (e.currentTarget.id == "publications"){
        this.setState({ showPubs: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    if (e.currentTarget.id == "about"){
        this.setState({ showAbout: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    if (e.currentTarget.id == "research"){
        this.setState({ showResearch: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    if (e.currentTarget.id == "join"){
        this.setState({ showJoin: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    if (e.currentTarget.id == "news"){
        this.setState({ showNews: true });
        // const containerDiv = document.getElementById("people");
        // const targetDiv = containerDiv.querySelector(".centreText");
        // targetDiv.classList.add("fadeOutAnimation");
    }
    document.querySelectorAll('.centreText').forEach(function(text){
        if (text.classList.contains("fadeInAnimationFast")){
            text.classList.remove("fadeInAnimationFast");
        }
        if (!text.classList.contains("fadeOutAnimation")){
            text.classList.add("fadeOutAnimation");
        }
        
    });


    

    // change all backgrounds
    document.querySelectorAll('.frame').forEach(function(frame){
        if (e.currentTarget.id != frame){
            if ((frame.id == "people") || (frame.id == "publications")) {
                frame.classList.add("dark");
                
            } else {
                frame.classList.add("light");
            }

        
        }
    })

    document.querySelectorAll('.frame').forEach(function(frame) {
        if (frame.classList.contains("fadeInAnimation")){
            frame.classList.remove("fadeInAnimation");
        }
        if (frame.classList.contains("frameSelected")){
            frame.classList.remove("frameSelected");
        }
        if (frame.classList.contains("animateFrameDark")){
            frame.classList.remove("animateFrameDark");
        }
        if (frame.classList.contains("animateFrameLight")){
            frame.classList.remove("animateFrameLight");
        }
        if (frame.id != e.currentTarget.id){
            frame.style.display = "none";
            frame.style.opacity = "0";   
        }

        if (frame.id == "people"){
            
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "58%";
            frame.style.width = "29%";
            frame.style.left = "0%";
            frame.style.top = "0%";
         } else if (frame.id == "about"){
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "28%";
            frame.style.width = "29%";
            frame.style.left = "0%";
            frame.style.top = "60%";
         } else if (frame.id == "publications"){
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "33%";
            frame.style.width = "68%";
            frame.style.left = "30%";
            frame.style.top = "0%";
         } else if (frame.id == "research"){
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "44%";
            frame.style.width = "39%";
            frame.style.left = "30%";
            frame.style.top = "44%";
         } else if (frame.id == "join"){
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "44%";
            frame.style.width = "28%";
            frame.style.left = "70%";
            frame.style.top = "44%";
         } else if (frame.id == "news"){
            frame.style.marginTop = "1%";
            frame.style.marginLeft = "1%";
            frame.style.height = "6%";
            frame.style.width = "98%";
            frame.style.left = "0%";
            frame.style.top = "90%";
         } 

        if (frame.classList.contains("contractFramePeople")){
            frame.classList.remove("contractFramePeople");
        }
        if (frame.classList.contains("contractFrameAbout")){
            frame.classList.remove("contractFrameAbout");
        }
        if (frame.classList.contains("contractFramePubs")){
            frame.classList.remove("contractFramePubs");
        }
        if (frame.classList.contains("contractFrameResearch")){
            frame.classList.remove("contractFrameResearch");
        }
        if (frame.classList.contains("contractFrameJoin")){
            frame.classList.remove("contractFrameJoin");
        }
        if (frame.classList.contains("contractFrameNews")){
            frame.classList.remove("contractFrameNews");
        }
        
    });
    if (document.getElementById("name").classList.contains("fadeInAnimation")){
        document.getElementById("name").classList.remove("fadeInAnimation");
    }
    document.getElementById("name").style.display = "none";
    document.getElementById("name").style.opacity = "0";


    if (document.getElementById(e.currentTarget.id)){
        if (e.currentTarget.id == "people" || e.currentTarget.id == "publications"){
            document.getElementById(e.currentTarget.id).classList.add("animateFrameDark");
        } else {
            document.getElementById(e.currentTarget.id).classList.add("animateFrameLight");
        }
        
        document.getElementById(e.currentTarget.id).classList.add("frameSelected");
        if (document.getElementById(e.currentTarget.id).classList.contains("frame")){
            document.getElementById(e.currentTarget.id).classList.remove("frame");
        }

        if (document.getElementById(e.currentTarget.id).classList.contains("contractFramePeople")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFramePeople");
        }
        if (document.getElementById(e.currentTarget.id).classList.contains("contractFrameAbout")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFrameAbout");
        }
        if (document.getElementById(e.currentTarget.id).classList.contains("contractFramePubs")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFramePubs");
        }
        if (document.getElementById(e.currentTarget.id).classList.contains("contractFrameResearch")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFrameResearch");
        }
        if (document.getElementById(e.currentTarget.id).classList.contains("contractFrameJoin")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFrameJoin");
        }
        if (document.getElementById(e.currentTarget.id).classList.contains("contractFrameNews")){
            document.getElementById(e.currentTarget.id).classList.remove("contractFrameNews");
        }
    }

    document.getElementById("sidebar").style.display = "block";
    document.getElementById("sidebar").classList.add("fadeInAnimation");
    this.setState({expanded: true, expandedPage: e.currentTarget.id});
  }

  
  render() {
    return (
      <div id = "mainContainer">
        <div id = "sidebar">
            <Sidebar page={this.state.expandedPage} changePage = {this.changePage} resetPage = {this.resetPage}
                showPeoplePage={this.showPeople}
                showPubsPage={this.showPubs}
                showAboutPage={this.showAbout}
                showResearchPage={this.showResearch}
                showNewsPage={this.showNews}
                showJoinPage={this.showJoin}
                hidePeoplePage={this.hidePeople}
                hidePubsPage={this.hidePubs}
                hideAboutPage={this.hideAbout}
                hideResearchPage={this.hideResearch}
                hideNewsPage={this.hideNews}
                hideJoinPage={this.hideJoin}
            />
        </div>
        <div id = "people" className = "frame" onClick={(e) => this.expandTheDiv(e)} >
            <div className = {"centreText whiteText"}>
                <h1>People</h1>
            </div>
            {this.state.showPeople && <People />}
        </div>
        <div id = "publications" className = "frame" onClick={(e) => this.expandTheDiv(e)}>
            <div className = {"centreText whiteText"}>
                <h1>Publications</h1>
            </div>
            {this.state.showPubs && <Pubs />}
        </div>
        <div id = "name" >
            <div className = {"leftText blackText"}>
                <h2>The X-LAB @ UBC Vancouver</h2>
            </div>
            <div id = "socials">
                <div id = "icons">
                    <SocialIcon url="https://linkedin.com" target="_blank" style={{ height: 60, width: 60 }}/>
                </div>
                <div id = "icons2">
                    <SocialIcon url="https://x.com" target="_blank" style={{ height: 60, width: 60 }}/>
                </div>
                <div id = "icons2">
                    <SocialIcon url="https://instagram.com" target="_blank" style={{ height: 60, width: 60 }} />
                </div>
                <div id = "icons2">
                    <SocialIcon url="https://discord.com" target="_blank" style={{ height: 60, width: 60 }}/>
                </div>
            </div>
            

        </div>
        <div id = "about" className = "frame" onClick={(e) => this.expandTheDiv(e)}>
            <div className = {"centreText blackText"}>
                <h1>About Us</h1>
            </div>
            {this.state.showAbout && <About />}
        </div>
        <div id = "research" className = "frame" onClick={(e) => this.expandTheDiv(e)}>
            <div className = {"centreText blackText"}>
                <h1>Research</h1>
            </div>
            {this.state.showResearch && <Research />}
        </div>
        <div id = "join" className = "frame" onClick={(e) => this.expandTheDiv(e)}>
            <div className = {"centreText blackText"}>
                <h1>Get Connected!</h1>
            </div>
            {this.state.showJoin && <Join />}
        </div>
        <div id = "news" className = "frame" onClick={(e) => this.expandTheDiv(e)}>
            {this.state.showNews && <News news = {NEWS}/>}
            {!this.state.showNews && (
            <div id = "newsWrapper">
                <div id = "dateBlock"> {NEWS[0].type}</div>
                <div id = "newsBlock"> {NEWS[0].date + " | " + NEWS[0].content} </div>
            </div>)}
            
        </div>
      </div>
    )
  }
}

export default Main;


// onclick setactive